import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    Drawer,
    Button,
    Typography,
    IconButton,
} from "@material-tailwind/react";
import { useInstallPrompt } from "../hooks/useInstallPrompt";

// Custom event to trigger install prompt display
const triggerInstallPrompt = () => {
    window.dispatchEvent(new CustomEvent('show-install-prompt'));
};

export default function NavigationMenu() {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { isInstallable, promptInstall, isIOSDevice } = useInstallPrompt();

    const menuItems = [
        { label: "Gjysma e natës", path: "/" },
        { label: "Pjesa e tretë e natës", path: "/pjesa-e-trete-e-nates" },
        { label: "Kohët e namazit", path: "/kohet-e-namazit" },
        { label: "Informacione", path: "/informacione" },
    ];

    // Add install menu item if app is installable and not already installed
    if (isInstallable) {
        menuItems.push({ label: "Instalo", path: null, isInstall: true });
    }

    const handleMenuClick = async (item) => {
        if (item.isInstall) {
            setOpen(false);
            // For iOS, trigger the prompt to show
            if (isIOSDevice) {
                triggerInstallPrompt();
            } else {
                await promptInstall();
            }
        } else {
            navigate(item.path);
            setOpen(false);
        }
    };

    const openDrawer = () => setOpen(true);
    const closeDrawer = () => setOpen(false);

    return (
        <>
            <div className="flex items-center gap-2">
                <Typography variant="h6" color="blue-gray" className="font-semibold">
                    Menyja
                </Typography>
                <IconButton
                    variant="text"
                    onClick={openDrawer}
                    className="text-blue-gray-700"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="h-10 w-10"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                        />
                    </svg>
                </IconButton>
            </div>
            <Drawer open={open} onClose={closeDrawer} placement="right" className="p-4">
                <div className="mb-6 flex items-center justify-between">
                    <Typography variant="h5" color="blue-gray">
                        Menyja
                    </Typography>
                    <IconButton variant="text" color="blue-gray" onClick={closeDrawer}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="h-9 w-9"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </IconButton>
                </div>
                    <nav className="flex flex-col gap-2">
                        {menuItems.map((item, index) => (
                            <Button
                                key={item.path || `install-${index}`}
                                variant={item.isInstall ? "filled" : location.pathname === item.path ? "filled" : "text"}
                                color={item.isInstall ? "blue" : location.pathname === item.path ? "blue" : "blue-gray"}
                                onClick={() => handleMenuClick(item)}
                                className="normal-case justify-start text-left text-xl py-3"
                                fullWidth
                            >
                                {item.label}
                            </Button>
                        ))}
                    </nav>
            </Drawer>
        </>
    );
}
